import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ProjectDto } from '@api/projects/interfaces';
import { UserDto } from '@api/users/interfaces';
import { ProjectRestService } from '@app/services/rest/project-rest.service';
import { Observable, Subscription } from 'rxjs';
import { SplitButtonElement } from '@app/components/elements/splitbutton/splitbutton.component';
import { Router } from '@angular/router';
import { userPages } from '@app/pages/user/user.routes';
import { select, Store } from '@ngrx/store';
import * as Reducers from '@app/store/reducers';
import { switchMap, tap } from 'rxjs/operators';

@Component({
	selector: 'app-user-roles',
	templateUrl: './user-roles.component.html',
	styleUrls: ['./user-roles.component.scss']
})
export class UserRolesComponent implements OnInit, OnDestroy, OnChanges {

	@Input() user: UserDto;
	cancelButton: SplitButtonElement = {
		title: 'actions.show_user_detail',
		icon: 'x',
		type: 'default',
		callback: () => this.returnToUserDetails(),
	};
	private activeUser: UserDto;
	private subscription: Subscription = new Subscription();
	isNotSameUser: boolean;

	projects$: Observable<ProjectDto[]>;

	constructor(private projectRestService: ProjectRestService,
				private router: Router,
				private store: Store<never>) {
	}

	ngOnChanges(): void {
		this.checkSameUser();
	}

	ngOnInit(): void {
		this.projects$ = this.store.pipe(
			select(Reducers.getUser),
			tap(state => {
				this.activeUser = state;
				this.checkSameUser();
			}),
			switchMap(() => {
				return this.projectRestService.listProjects$();
			}));
		this.subscription.add(this.projects$.subscribe());
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	returnToUserDetails(): void {
		this.router.navigate([userPages.edit.base(this.user.username)]);
	}

	checkSameUser(): void {
		this.isNotSameUser = this.user?.username !== this.activeUser?.username;
	}
}
